import Vue from 'vue';
import VModal from 'vue-js-modal';
import { ValidationProvider, extend } from 'vee-validate';
import VueAnalytics from 'vue-analytics';
import Icon from '@/components/svg/Icon.vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';

extend('secret', {
  validate: (value) => value === 'example',
  message: 'This is not the magic word',
});

Vue.use(VModal, { dynamic: true, dialog: true, injectModalsContainer: true });
Vue.config.productionTip = false;
if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID) {
    Vue.use(VueAnalytics, {
        id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    });
}
Vue.component('icon', Icon);
Vue.component('validation-provider', ValidationProvider);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
